import { defineComponent as _defineComponent } from 'vue'
import MyProjectsSection from '@/views/my-projects/components/MyProjectsSection.vue';
import InvoicesTable from '@/views/my-projects/components/invoices/InvoicesTable.vue';
import useInvoice from '@/views/my-projects/composables/useInvoice';
import { computed } from 'vue';
import { InvoiceStatus } from '@/models/Invoice';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicesCurrent',
  setup(__props) {

const { componentInvoicesUserAsSender } = useInvoice();
const { tUserFallback: t, userId } = useUser('self');

/**
 * Computed list of invoices with specific statuses.
 */
const invoicesStatusFiltered = computed(() => componentInvoicesUserAsSender.value.filter((invoice) => [
  InvoiceStatus.Due,
  InvoiceStatus.Sent,
  InvoiceStatus.Open,
].includes(invoice.status)));

/**
 * Computed list of due invoices not sent by the user.
 */
const dueInvoices = computed(() => invoicesStatusFiltered.value.filter((invoice) => {
  const isUserSender = invoice.user.userId === userId.value;
  const isDueStatus = invoice.status === InvoiceStatus.Due;

  return isDueStatus && !isUserSender;
}));

/**
 * Computed property: Filters all unpaid invoices that are due within the next 7 days.
 * Returns invoices with a due date in 1 to 7 days.
 */
const soonInvoices = computed(() => invoicesStatusFiltered.value.filter((invoice) => {
  const dueDate = new Date(invoice.dueDate).getTime();
  const today = new Date().getTime();
  const daysUntilDue = Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24));
  const isUserSender = invoice.user.userId === userId.value;

  return daysUntilDue > 0 && daysUntilDue <= 7 && !isUserSender;
}));

return { __sfc: true,componentInvoicesUserAsSender, t, userId, invoicesStatusFiltered, dueInvoices, soonInvoices, MyProjectsSection, InvoicesTable }
}

})